import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

const SessionTimeoutWarning = () => {
  const { usuario } = useAuth();
  const [showWarning, setShowWarning] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);

  // Configuração do timeout (30 minutos) e aviso (5 minutos antes)
  const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutos
  const WARNING_TIME = 5 * 60 * 1000; // 5 minutos antes do timeout

  useEffect(() => {
    if (!usuario) return;

    let interval;
    let lastActivity = Date.now();

    // Atualizar timestamp de atividade
    const updateActivity = () => {
      lastActivity = Date.now();
    };

    // Eventos para detectar atividade
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
    events.forEach(event => {
      document.addEventListener(event, updateActivity, { passive: true });
    });

    // Intervalo para verificar tempo restante
    interval = setInterval(() => {
      const now = Date.now();
      const timeSinceLastActivity = now - lastActivity;
      const timeRemaining = SESSION_TIMEOUT - timeSinceLastActivity;

      if (timeRemaining <= 0) {
        setShowWarning(false);
      } else if (timeRemaining <= WARNING_TIME) {
        setShowWarning(true);
        setTimeLeft(Math.ceil(timeRemaining / 1000)); // Converter para segundos
      } else {
        setShowWarning(false);
      }
    }, 1000);

    return () => {
      events.forEach(event => {
        document.removeEventListener(event, updateActivity);
      });
      if (interval) clearInterval(interval);
    };
  }, [usuario]);

  if (!showWarning || !usuario) return null;

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <div className="fixed top-4 right-4 z-50 animate-fade-in">
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg shadow-lg p-4 max-w-sm">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0">
            <svg className="w-6 h-6 text-yellow-600 animate-pulse-slow" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div className="flex-1">
            <h3 className="text-sm font-medium text-yellow-800 mb-1">
              Sessão expirando
            </h3>
            <p className="text-sm text-yellow-700 mb-3">
              Sua sessão expirará em{' '}
              <span className="font-semibold">
                {minutes}:{seconds.toString().padStart(2, '0')}
              </span>
            </p>
            <div className="flex gap-2">
              <button
                onClick={() => {
                  // Simular atividade para resetar o timer
                  const event = new MouseEvent('mousemove', {
                    view: window,
                    bubbles: true,
                    cancelable: true
                  });
                  document.dispatchEvent(event);
                  setShowWarning(false);
                }}
                className="px-3 py-1 bg-yellow-600 text-white text-xs font-medium rounded hover:bg-yellow-700 transition-colors"
              >
                Manter sessão
              </button>
              <button
                onClick={() => setShowWarning(false)}
                className="px-3 py-1 bg-white text-yellow-800 text-xs font-medium rounded border border-yellow-300 hover:bg-yellow-50 transition-colors"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutWarning;